import { Field, Filter, MultipleSelect } from "components/commons";
import { useMount } from "hooks";
import { allLocationRequest } from "mappers";
import React, { useCallback, useMemo } from "react";
import { mapObject } from "services";
import lang from "translations";

const SupplyItemFilter = ({
  filterState,
  requestState,
  modifyFilter,
  clearFilter,
  applyFilter,
  locationRequest,
  locationOptions,
}) => {
  const { request: searchLocationRequest, loading: loadingLocations } = locationRequest;

  useMount(() => {
    fetchLocationRequest(requestState);
  });

  const fetchLocationRequest = useCallback(
    (requestState) => {
      searchLocationRequest(mapObject({ ...requestState }, allLocationRequest));
    },
    [searchLocationRequest]
  );

  const applyFilterCb = useCallback(
    async (searchKey) => {
      await applyFilter(searchKey);
    },
    [applyFilter]
  );

  const clearFilterCb = useCallback(() => {
    clearFilter();
  }, [clearFilter]);

  const stockLevelOptions = useMemo(() => {
    return [
      {
        text: lang.inStock,
        value: "IN_STOCK",
      },
      {
        text: lang.reachedReorderPoint,
        value: "REACHED_REORDER_POINT",
      },
      {
        text: lang.belowParLevel,
        value: "BELOW_PAR_LEVEL",
      },
      {
        text: lang.zeroInventory,
        value: "OTHERS",
      },
    ];
  }, []);

  return (
    <Filter
      placeholder={lang.searchSupplyItemBy}
      className="mb-lg"
      onClear={clearFilterCb}
      onApply={async (searchKey) => {
        await applyFilterCb(searchKey);
      }}
      filterState={filterState}
    >
      <Field className="col-span-4" filterLabel={lang.outlet}>
        <MultipleSelect
          name="locations"
          selectAllText={lang.allLocations}
          loading={loadingLocations}
          options={locationOptions}
          value={filterState.locations}
          isAll={filterState.locations && filterState.locations.length === 0}
          onChange={(name, obj) => {
            modifyFilter(name, { value: obj.value });
          }}
          placeholder={!locationOptions.length ? lang.noLocationAvailable : lang.selectLocation}
        />
      </Field>
      <Field className="col-span-4" filterLabel={lang.stockLevels}>
        <MultipleSelect
          name="stockLevels"
          defaultAll={true}
          selectAllText={lang.allStockLevels}
          isAll={filterState.stockLevels && filterState.stockLevels.length === 0}
          options={stockLevelOptions}
          value={filterState.stockLevels}
          onChange={(name, obj) => {
            modifyFilter(name, { value: obj.value });
          }}
          placeholder={lang.selectStockLevel}
        />
      </Field>
    </Filter>
  );
};

export default SupplyItemFilter;
